module.exports = __webpack_public_path__ + "static/media/32-4.f0615bcf.mp3";